<template>
  <div style="height: 1080px" v-if="showActivator">
    <b-sidebar
      :key="'map-side-bar-' + mapIndex"
      v-for="(map, mapIndex) in mapObj.images"
      :id="'sidebar-map-' + mapIndex"
      class="side-map"
      :title="map.name ? map.name : titleText"
      right
      backdrop
      :width="map.width ? map.width + 'px' : '1500px'"
      :height="'1080px'"
      shadow
      no-header-close
      @change="showActivatorFunc"
      sidebar-class="slider-canvas-parameter"
    >
      <img :src="giveMeImagePlease(map.src)" style="width: 100%; height: 100%; object-fit: scale-down; padding: 20px" />
      <!-- <slot name="activator"></slot>
      <slot name="content"></slot> -->
    </b-sidebar>
  </div>
</template>

<script>
/**
 * @namespace MbMap
 */

/**
 * przesyłane Propsy
 * @property {Object} mapObj - zawiera dane niezbędne do stworzenia sidebaru z obrazkiem
 * @property {String} titleText - nazwa sidebaru (wyświetlana na górze elementu)
 * @property {null} showActivator - Boolowska wartość czy panel ma być widoczbt czt bue
 *
 * @property {Array} imgaes zawiera X elementów (każy ma osobny button!) objekt w tablicy images musi zawierac tylko src!
 * @example
 *  {
 *     type: 'MbMap',
 *     images: [
 *       {
 *         name: 'Paweł',
 *         src: 'games/page095_game0/img/mapa.jpg',
 *         width: 1500,
 *         style: { height: '120px', background: 'blue' },
 *       },
 *     ],
 *   },
 *
 */
export default {
  name: 'mb-map',
  props: {
    mapObj: {
      type: Object,
      default: function () {
        return {};
      },
    },
    titleText: {
      type: String,
      default: function () {
        return '';
      },
    },
    showActivator: {
      type: null,
      default: function () {
        return true;
      },
    },
  },
  methods: {
    /**
     * @method giveMeImagePlease
     * @param  {String}  path ścieżka do elementu
     * @return {String}       ścieżka do elementu z uwzględnieniem aktywnego multibooka i ścieżki statycznej
     */
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * @method showActivatorFunc
     * @param  {event}  e zdarzebie
     * emituje zdarzenie u rodzica
     */
    showActivatorFunc(e) {
      this.$emit('showActivator', { payload: e });
    },
  },
};
</script>

<style>
#sidebar-right {
  width: 1500px;
  height: 1080px !important;
}
#sidebar-map-0,
#sidebar-map-1,
#sidebar-map-2,
#sidebar-map-3,
#sidebar-map-4 {
  min-height: 1080px !important;
  height: 1080px !important;
}
.b-sidebar-backdrop {
  height: 1080px !important;
}
/* .slider-canvas-parameter {
} */
</style>
